import { useMemo } from "react";
import { Tabs } from "antd";
import Activities from ".";
import { FileOutlined, HistoryOutlined } from "@ant-design/icons";
import Attachments from "../Attachments";

const TaskTabs = (props) => {
  const items = useMemo(
    () => [
      {
        key: "attachments",
        label: "Attachments",
        children: <Attachments {...props} />,
        icon: <FileOutlined />,
      },
      {
        key: "activities",
        label: "Activities",
        children: <Activities {...props} />,
        icon: <HistoryOutlined />,
      },
    ],
    [props],
  );

  return (
    <Tabs defaultActiveKey="attachments" items={items} destroyOnHidden={true} />
  );
};

export default TaskTabs;
